import React, { Component } from 'react';

import {Button} from 'react-materialize'

import * as ReadableAPI from './ReadableApi'

import { connect } from 'react-redux'

import { initLocation } from './actions'

class ContactForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      type:'',
      message:'',
      contactName:'',
      contactEmail:'',
      contactAsunt:'',
      contactMessage:'',
      Sending: false,
      country: '',
      isValidated: false
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleAsuntChange = this.handleAsuntChange.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onError = this.onError.bind(this)
  }

  componentDidMount(){
    this.setState({
      country: this.props.geo
    });
  }

  componentWillReceiveProps(next_props) {
    if(next_props.geo !== this.state.country){
      this.setState({
        country: next_props.country.location,
      });
    }
  }

  validate = () => {
    const formEl = this.formEl;
    const formLength = formEl.length;
    if (formEl.checkValidity() === false) {
      for (let i = 0; i < formLength; i++) {
        const elem = formEl[i];
        const errorLabel = elem.parentNode.querySelector(".invalid-feedback");
        if (errorLabel && elem.nodeName.toLowerCase() !== "button") {
          if (!elem.validity.valid) {
            errorLabel.textContent = elem.validationMessage;
          } else {
            errorLabel.textContent = "";
          }
        }
      }
      return false;
    } else {
      for (let i = 0; i < formLength; i++) {
        const elem = formEl[i];
        const errorLabel = elem.parentNode.querySelector(".invalid-feedback");
        if (errorLabel && elem.nodeName.toLowerCase() !== "button") {
          errorLabel.textContent = "";
        }
      }
      return true;
    }
  };

  handleSubmit(event) {
    event.preventDefault()
    this.setState({ type: 'info', message: 'Sending…' });
    let data = {
        "form_name": this.state.contactName,
        "form_asunt": this.state.contactAsunt,
        "form_country": this.state.country,
        "form_email": this.state.contactEmail,
        "form_msg": this.state.contactMessage
      }

    if (this.validate()) {
      if(data.form_name !== '' && data.form_asunt !== '' && data.form_country !== '' && data.form_email !== '' && data.form_msg !== ''){
          this.setState({ 
            Sending: true
          });
          ReadableAPI.newEmail(data).then((obj) => {
            console.log(obj)
          })
          .catch((e)=>{
            console.log(e)
          })
      }
    }

    this.setState({ isValidated: true });

  }

  handleNameChange(event) {
    this.setState({contactName: event.target.value});
  }

  handleAsuntChange(event) {
    this.setState({contactAsunt: event.target.value});
  }

  handleEmailChange(event) {
    this.setState({contactEmail: event.target.value});
  }

  handleMessageChange(event) {
    this.setState({contactMessage: event.target.value});
  }

  onSubmit(){
    this.setState({ 
      type: 'success', 
      message: 'We have received your message and will get in touch shortly. Thanks!' 
    });
  }

  onError(){
    this.setState({ 
      type: 'danger', 
      message: 'Sorry, there has been an error.  Please try again later or visit us at SZB 438.' 
    });
  }

  render() {
    const props = [...this.props];

    let classNames = [];
    if (props.className) {
      classNames = [...props.className];
      delete props.className;
    }

    if (this.state.isValidated) {
      classNames.push("was-validated");
    }

    return (
      <div className="item-form">
        { !this.state.Sending &&
          <form {...props} className={classNames} noValidate ref={form => (this.formEl = form)} onSubmit={this.handleSubmit}>
            <div className="cont-formu">
              <fieldset className="form-group">
              <label htmlFor="form_name">Nombre</label>
              <input value={this.state.contactName} className={"form-control"} id="form_name" type="text"  onChange={this.handleNameChange} required={true}/>
              <div className="invalid-feedback" />
              </fieldset>

              <fieldset className="form-group">
              <label htmlFor="form_email">E-mail:</label>
              <input value={this.state.contactEmail} className={"form-control"} id="form_email" type="email" onChange={this.handleEmailChange} required={true}/>
              <div className="invalid-feedback" />
              </fieldset>

              <fieldset className="form-group">
              <label htmlFor="form_asunt">Asunto:</label>
              <input value={this.state.contactAsunt} className={"form-control"} id="form_asunt" type="text" onChange={this.handleAsuntChange} required={true}/>
              <div className="invalid-feedback" />
              </fieldset>

              <fieldset className="form-group">
              <label htmlFor="form_msg">Mensaje:</label>
              <textarea value={this.state.contactMessage} className={"form-control"} id="form_msg" onChange={this.handleMessageChange} cols="40" rows="40" required={true}></textarea>
              <div className="invalid-feedback" />
              </fieldset>
              <Button waves='light' className="btn-col" type={"submit"}> Enviar </Button>
            </div>
          </form>
        }
        { this.state.Sending &&
          <div>
            <div className="cont-msn">
              <p>Gracias por contactanos,el equipo de <span>VcMultichanel.com</span> se comunicara con usted proximamente.</p>
            </div>
          </div>
        }
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(ContactForm)



// WEBPACK FOOTER //
// ./src/Contactform.js